import React from 'react';
import AccordionItem from './AccordionItem';

const MarineSection = () => {
    return (
        <section id="marine" className="container mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-serif-display text-center font-bold text-gray-800 mb-12 section-title">Marine & Cargo Insurance</h2>
            <div className="md:flex md:flex-row-reverse md:items-center md:space-x-12 md:space-x-reverse bg-white p-8 md:p-12 rounded-lg shadow-lg">
                <div className="md:w-1/2 mb-8 md:mb-0">
                    <img src="/MarineNew.png" alt="Container ship carrier at sea" className="rounded-lg shadow-md w-full h-auto object-cover" style={{ aspectRatio: '3/2' }} onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/93c5fd/1e293b?text=Image+Not+Found'; }} />
                </div>
                <div className="md:w-1/2">
                    <p className="text-lg mb-6">For businesses involved in domestic or international trade, Marine & Cargo insurance is indispensable. It provides coverage for goods in transit over sea, air, or land, protecting against loss or damage from a variety of risks.</p>
                    <div className="accordion">
                        <AccordionItem title="Key Marine Policy Types">
                            <div>
                                <h5 className="font-bold text-gray-800">Specific Voyage Policy</h5>
                                <p>Ideal for businesses with infrequent shipments. This policy provides cover for a single transit from a point of origin to a final destination. The cover ends once the cargo reaches its destination.</p>
                            </div>
                            <div>
                                <h5 className="font-bold text-gray-800">Marine Open Policy</h5>
                                <p>Suited for businesses with regular and frequent shipments. This is an annual policy that provides continuous coverage for all cargo movements throughout the year. It simplifies administration as you don't need to get a new policy for each transit, but you must declare each shipment to the insurer.</p>
                            </div>
                            <div>
                                <h5 className="font-bold text-gray-800">Sales Turnover Policy (STOP)</h5>
                                <p>The most comprehensive solution, this annual policy covers all transits (imports, domestic purchases, exports, inter-depot transfers) under a single umbrella. The premium and sum insured are based on your estimated annual sales turnover, eliminating the need to declare individual shipments and drastically reducing administrative work.</p>
                            </div>
                        </AccordionItem>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MarineSection;
